import * as React from "react";
import { HashLink as Link } from "react-router-hash-link";
import Slider, { Settings } from "react-slick";
import cx from "classnames";

import { PortfolioCategory } from "../../../models";
import { Wrapper } from "../../../components";
import "./Portfolio.css";

export interface PortfolioProps {
  dropdownOpen: boolean;
  toggleDropdown: () => void;
  activeFilter?: PortfolioCategory;
  children?: JSX.Element[];
  filters: JSX.Element[];
}

const settings: Settings = {
  slidesToShow: 3,
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  dots: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const Portfolio = ({
  children,
  filters,
  activeFilter,
  dropdownOpen,
  toggleDropdown,
}: PortfolioProps): JSX.Element => (
  <Wrapper>
    <div className="row">
      <div className="col-md-6">
        <h1 className="title">
          sản phẩm <b>thiết kế</b> với <span>100% đam mê</span>
        </h1>
      </div>

      <div className="col-md-6">
        <div className={cx("filters dropdown", { open: dropdownOpen })}>
          <button
            className="dropdown-toggle"
            type="button"
            onClick={toggleDropdown}
          >
            {activeFilter ? activeFilter.name : "Tất cả"}
            <span className="caret" />
          </button>
          <ul className="dropdown-menu dropdown-menu-right">{filters}</ul>
        </div>
      </div>
    </div>
    {children &&
    children.length > 0 && (
      <Slider className="portfolio-carousel" {...settings}>
        {children.map((slide, index) => <div key={index}>{slide}</div>)}
      </Slider>
    )}
    <p className="call-to-action">
      <Link className="call-to-action__button" to="/#products" replace>
        Tìm hiểu giá
      </Link>
    </p>
  </Wrapper>
);

export default Portfolio;



// WEBPACK FOOTER //
// ./src/routes/PortfolioCarousel/components/Portfolio.tsx